const fullcontJump = require('../../../../../components/fullcont/fullcont-jump')

export function jumperToPurchase(detail) {
  const line = detail.ev?.target?.closest('.line')
  const otherFieldElement = line?.querySelector('.expense_id .otherField')
  const rawOtherField = otherFieldElement?.getAttribute('otherField')

  if (!rawOtherField) {
    return
  }

  let otherField

  try {
    otherField = JSON.parse(rawOtherField)
  } catch (error) {
    return
  }

  const purchaseCode = String(otherField.purchase_code || '').trim()

  if (purchaseCode === '') {
    return
  }

  fullcontJump.start({
    actJump: 'goToPurchase',
    dtId: 'purchase-dt',
    toSearch: purchaseCode,
  })
}
